import { useParams } from "@tanstack/react-router"
import type { FC } from "react"

import useGetPaymentTerm from "../hooks/useGetPaymentTerm"
import { usePaymentTermMutation } from "../hooks/usePaymentTermMutation"
import type { PaymentTermsSchemaFormValues } from "../schemas/PaymentTermsSchema"
import { serializePaymentTermsForm } from "../utils/paymentTerms"

import PaymentTermContainer from "./PaymentTermContainer"

import type { PaymentTermUpdateFailure } from "@/graphql/codegen/graphql"
import { NotificationType } from "@/schemas/notification"
import { useNotificationsStore } from "@/stores/useNotificationsStore"

const EditPaymentTermsContainer: FC = () => {
  const { paymentTermId } = useParams({ from: "/app/admin/accounting/payment-term/$paymentTermId" })
  const { paymentTerm } = useGetPaymentTerm({ paymentTermId })

  const { enqueueNotification } = useNotificationsStore()
  const { updatePaymentTerm } = usePaymentTermMutation()

  const onSubmit = async (data: PaymentTermsSchemaFormValues) => {
    const formattedData = serializePaymentTermsForm(data)

    const { error, data: result } = await updatePaymentTerm({
      input: { ...formattedData, paymentTermId },
    })
    if (error || (result?.paymentTerm?.update as PaymentTermUpdateFailure)?.error) {
      enqueueNotification({
        type: NotificationType.Error,
        content: <p>Payment term update failed</p>,
      })
    } else {
      enqueueNotification({
        type: NotificationType.Success,
        content: <p>Payment term successfully updated</p>,
      })
    }
  }

  return <PaymentTermContainer paymentTerm={paymentTerm ?? undefined} onSubmit={onSubmit} />
}

export default EditPaymentTermsContainer
